/* @flow */
import { ActionTypes } from 'constants/PromptConstants';
import { dispatcher } from 'lib/Dispatcher';
import Prompt from 'entities/Prompt';
import CurrentUser from 'auth/CurrentUser';

const PromptActions = {
  recordDismissal(name: string): Promise<void> {
    const prompt = new Prompt({ action: name, response: 'dismissed' });
    dispatcher.dispatch({
      prompt,
      type: ActionTypes.PROMPT_DISMISSED,
    });
    return Prompt.savePrompt(prompt);
  },

  recordDismissExistingPrompt(prompt: ?Object) {
    if (!prompt) {
      return;
    }
    prompt.set('response', 'dismissed');
    Prompt.markDismissed(prompt);

    dispatcher.dispatch({
      prompt,
      type: ActionTypes.EXISTING_PROMPT_DISMISSED,
    });
  },

  recordDismissPromptsInventoryPrompt(prompt: ?Object) {
    if (!prompt) {
      return;
    }
    prompt.set('response', 'dismissed');
    Prompt.markDismissed(prompt);
    CurrentUser.getUser().getPromptsInventory().remove(prompt);
    dispatcher.dispatch({
      type: ActionTypes.USER_PROMPT_DISMISSED,
    });
  },
};

export default PromptActions;



// WEBPACK FOOTER //
// ./src/actions/PromptActions.js